import React, { useCallback, useEffect } from "react";
import style from "./stylesheets/Leaderboard.module.scss";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getUID } from "../helpers/localStorage";

const Leaderboard = ({ userData }) => {
    const functions = getFunctions();
    const [leaderboardData, setLeaderboardData] = React.useState(null);

    const fetchLeaderboard = useCallback(async () => {
        let result;
        try {
            const func = httpsCallable(functions, "getLeaderboard");
            result = await func();
        } catch(e) {
            console.error(e);
            return;
        }
        if(!result.data || !result.data.leaderboard) {
            console.log("Failed to fetch leaderboard");
            console.log(result);
            return;
        }
        return result.data.leaderboard;
    }, [functions]);

    useEffect(() => {
        const loadData = async () => {
            const data = await fetchLeaderboard();
            if(data) {
                setLeaderboardData(data);
            }
        };
        loadData();
    }, [fetchLeaderboard]);

    if(leaderboardData === null) {
        return <div className={style.leaderboard}>
            <h2>Leaderboard</h2>
            <p>Loading...</p>
        </div>;
    }

    if(leaderboardData.length === 0) {
        return <div className={style.leaderboard}>
            <p>No one has scored any points yet. Will you be the first?</p>
        </div>;
    }

    const leaderboardEntries = [...leaderboardData];

    if(leaderboardData.find(i => i.uid === getUID()) === undefined) {
        leaderboardEntries.push({
            uid: userData?.uid,
            name: userData?.name || "You",
            points: userData?.points || 0,
        });
    }

    const entries = leaderboardEntries.map(i => {
            return (
                <div className={style.leaderboard_entry}>
                    <div className={style.info_box}>
                        <h2>{i.name}</h2>
                        <p>{i.points} points</p>
                    </div>
                </div>
            );
        });
    
        return (
            <div className={style.leaderboard}>
                {entries}
            </div>
        );
};

export default Leaderboard;
